import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_accessibility from 'highcharts/modules/accessibility';
import { UniqueChartService } from '../../unique-chart.service';
import Stock from 'highcharts/modules/stock';
import { Observable, Subscription } from 'rxjs';
import { BarserviceService } from '../../../../barchart/barchart/barservice.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SignificanceService } from 'src/app/common/services/significance.service';
Stock(Highcharts);
@Component({
  selector: 'app-funnelchart1',
  templateUrl: './funnelchart1.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Funnelchart1Component {
  constructor(
    private http: HttpClient,
    private uniquechartservice: UniqueChartService,
    private barService: BarserviceService,
    private _configService: SnapshotService,
    private significanceService: SignificanceService
  ) { }

  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;
  @Input() id: any;
  @Input() height: any;
  @Input() data: any;
  maxDataPoints: any = 2;
  significanceValue: any = "None";
  chartMainData: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  private subscriptions: Subscription = new Subscription();
  ngOnInit(): void {
    this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
    this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
    this.subscriptions.add(
      this._configService.confedenceValue.subscribe(value => {
        this.DefaultConfidenceLevel = value;
        this.updateSig();
      }));
    this.subscriptions.add(
      this._configService.significanceValue.subscribe(value => {
        this.significanceValue = value;
        this.updateSig();
      }));

  }


  ngOnChanges(changes: SimpleChanges) {
    this.updateSig();
  }

  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.seriescolor = this.uniquechartservice.color;
        this.seriesgradientcolor = this.uniquechartservice.linearGradients1;
        this.samplesizeconstant = this.uniquechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'right';
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
        this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
        this.plotChart(
          'chart-container' + this.id,
          this.jsondata['data'],
          this.chartproperties
        );
      }));
  }

  customization(): Observable<any[]> {
    let custom = this.uniquechartservice.FunnelChartCustomizationList();
    return custom;
  }

  arrangeArrayDescending1(data: any[]): any[] {
    data.sort((a, b) => {
      const valueA = parseFloat(a['Rounded Value']);
      const valueB = parseFloat(b['Rounded Value']);

      // Handle null values
      if (isNaN(valueA) && isNaN(valueB)) {
        return 0; // Both are null, keep their relative order
      }
      if (isNaN(valueA)) {
        return 1; // Null should come after any number
      }
      if (isNaN(valueB)) {
        return -1; // Null should come after any number
      }

      // Handle 0 values
      if (valueA === 0 && valueB === 0) {
        return 0; // Both are 0, keep their relative order
      }
      if (valueA === 0) {
        return 1; // 0 should come after any other number
      }
      if (valueB === 0) {
        return -1; // 0 should come after any other number
      }

      // Sort in descending order of Rounded Value
      return valueB - valueA;
    });

    return data;
  }


  preparemainChartData(data: any) {
    this.chartMainData = [];

    let i = 0;
    data.forEach((lev1: any) => {
      lev1.metricSelected.metrics.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {

            "Series Name": lev2.metricName,
            "Category Name": lev1.submetricName,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    })

  }

  chart: any;
  seriesdata: any;
  xaxis: any = [];
  preparechartdata(data: any, islowsample: any, isgradient: any) {
    let seriesdata: any[] = [];
    let xaxis: any = [];
    let i = 0;
    // let data1 = this.arrangeArrayDescending(data);
    let data1 = data;

    const valuesArray = data.map((item: any) => item.Value);
    const valuesArray2 = data.map((item: any) => ({
      value: item.Value != null || NaN
        ? item.Value : 'NA',
      samplesize: item["Sample size"]
    }));
    const valuesArray1 = valuesArray2.map((item: any) =>
      this._configService.CheckLSorIScondition(this._configService.userRole, item.value, item.samplesize)
    );
    // ;
    let diff = valuesArray1.slice(1).map((currentValue: any, index: any) => {
      currentValue = currentValue.toString();
      let previousValue = valuesArray1[index].toString();
      switch (true) {
        case (Math.round(currentValue).toString() === '0' && previousValue.toString() == 'I/S'):
          return '0';
        case (Math.round(currentValue).toString() === '0' && Math.round(previousValue).toString() === '0'):
        case (Math.round(currentValue).toString() === '0' && previousValue.toString() === 'NA'):
        case (currentValue.toString() === 'NA' && Math.round(previousValue).toString() === '0'):
        case (currentValue.toString() === 'NA' && previousValue.toString() === 'I/S'):
          return 'NA';
        case (Math.round(currentValue).toString() === '0' && !isNaN(previousValue.toString())):
        case (Math.round(currentValue).toString() === '0' && previousValue.toString().includes('*')):
          return '0';
        case (currentValue.toString() === 'NA' && !isNaN(previousValue.toString())):
        case (currentValue.toString() === 'NA' && previousValue.toString().includes('*')):
          return 'NA';

        case (currentValue.toString() === 'I/S' && Math.round(previousValue).toString() === '0'):
          return 'NA';
        case (currentValue.toString() === 'I/S' && previousValue.toString() === 'I/S'):
          return 'I/S';

        case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && Math.round(previousValue).toString() === '0'):
        case (currentValue.toString().includes('*') && Math.round(previousValue).toString() === '0'):
        case (currentValue.toString().includes('*') && currentValue.toString().match(/\d+(\.\d+)?/)![0] == "0"):
          return 'NA';

        case (currentValue.toString() === 'I/S' && previousValue.toString() === 'NA'):
          return 'NA';
        case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'NA'):
        case (currentValue.toString().includes('*') && previousValue.toString() === 'NA'):
          return 'NA';
        case (currentValue.toString() === 'NA' || previousValue.toString() === 'NA'):
          return 'NA';
        case (!currentValue.toString().includes("*") && !isNaN(currentValue.toString()) && previousValue.toString() === 'I/S'):
          return 'I/S';
        case (currentValue.toString().includes('*') && previousValue.toString() === 'I/S'):
          return 'I/S';
        case (currentValue.toString() === 'I/S' && !isNaN(previousValue.toString())):
          return Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) * 100;
        case (currentValue.toString() === 'I/S' && previousValue.toString().includes('*')):
          previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
          return Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(valuesArray2[index - 1]).toFixed(this.chartproperties.decimalRoundOff)) * 100 + "*";
        default:
          currentValue = /\d+(\.\d+)?/.test(currentValue.toString()) ? currentValue.toString().match(/\d+(\.\d+)?/)![0] : currentValue.toString();
          previousValue = /\d+(\.\d+)?/.test(valuesArray1[index].toString()) ? previousValue.toString().match(/\d+(\.\d+)?/)![0] : previousValue.toString();
          let answer = (Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff))) * 100;
          return Number.isNaN(answer) ? "NA" : answer;
      }
      // if (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
      //   return 0;
      // } else if (Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff)) === 0) {
      //   return "NA";
      // } else {
      //   return (Number(parseFloat(currentValue).toFixed(this.chartproperties.decimalRoundOff)) / Number(parseFloat(previousValue).toFixed(this.chartproperties.decimalRoundOff))) * 100;
      // }
    });

    diff = diff.filter((item: any) => {
      return item != undefined
    })

      ;
    let roundedValues = data1.map(function (item: any) {
      return item['Rounded Value'];
    });

    // Find the maximum value

    let maxdatapoint = Math.max.apply(Math, roundedValues);
    let maxdatapoint2 = Math.max(...diff);
    // let maxdatapoint = parseFloat(data1[0]['Rounded Value']);
    let series1: any = {
      name: 'Other',
      data: [],
      borderWidth: 0,
      shadow: false,
      pointPadding: 0.1,
      groupPadding: 0.1,
      // pointWidth:2
    };
    let series2: any = {
      name: data[0]['Series Name'],
      data: [],
      pointPadding: 0.1,
      groupPadding: 0.1,
      // pointWidth:2
    };
    let series3: any = {
      name: 'Other',
      data: [],
      borderWidth: 0,
      shadow: false,
      pointPadding: 0.1,
      groupPadding: 0.1,
      // pointWidth:2
    };
    data1.forEach((dat: any) => {
      let value =
        isNaN(parseFloat(dat['Rounded Value'])) ||
          parseFloat(dat['Rounded Value']) == null
          ? null
          : Number(parseFloat(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
      let finalvalue: any = !islowsample
        ? value
        : parseFloat(dat['Sample size']) > this.samplesizeconstant
          ? value
          : 0;
      xaxis.push(dat['Series Name']);
      let s1 = {
        name: 'Others',
        y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 1000 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
        color: 'transparent',
        dataLabels: { enabled: false },
      };
      let s2 = {
        name: dat['Series Name'],
        y: this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue,
        indexValue: this._configService.CheckLSorIScondition(this._configService.userRole, dat['ValueForIndex']?.toString(), dat['Sample size']).includes("I/S") || dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'],
        actualIndexValue:dat['ActualIndexValue'],
        y1: finalvalue,
        actualcolor: this.seriescolor?.[i] ,
        conversion: diff[i],
        color: !isgradient
          ? this.seriescolor?.[i]
          : this.seriesgradientcolor[i],
        samplesize: dat['Sample size'],
        cov: dat['Change value vs PY'],
        significance: dat['Significance'],
        significance2: dat['Significance2'],
        tooltip: '',
        isPercentage: dat["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: dat['Significance_Value']
      };
      let s3 = {
        name: 'Others',
        y: (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2 == 0 ? 1000 : (maxdatapoint - (this._configService.CheckLSorIScondition(this._configService.userRole, finalvalue?.toString(), dat['Sample size']).includes("I/S") || finalvalue == null ? 0 : finalvalue)) / 2,
        color: 'transparent',
        dataLabels: { enabled: false },
      };
      series1.data.push(s1);
      series2.data.push(s2);
      series3.data.push(s3);

      if (i < data1.length - 1) {
        let s11 = {
          name: 'Others',
          y: 1000,
          y1: -1,
          color: 'transparent',
          dataLabels: { enabled: false },
          pointWidth: 2,
        };
        let s22 = {
          name: '',
          y: 1000,
          y1: -1,
          actualcolor: 'transparent',
          conversion: diff[i++],
          color: 'transparent',
          samplesize: dat['Sample size'],
          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          tooltip: '',
          isPercentage: true,
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat['Significance_Value'],
          // dataLabels: { enabled: false },
          pointWidth: 2,
        };
        let s33 = {
          name: 'Others',
          y: 1000,
          y1: -1,
          color: 'transparent',
          dataLabels: { enabled: false },
          pointWidth: 2,
        };


        series1.data.push(s11);
        series2.data.push(s22);
        series3.data.push(s33);
        xaxis.push('');
      }

    });
    seriesdata = [series1, series2, series3];
    this.seriesdata = seriesdata;
    this.xaxis = xaxis;
    ;
  }
  @Input() popUpp: any;
  @Input() popUp: any;
  plotLines: any = [];
  plotChart(containerId: any, jsondata: any, chartproperties: any) {
    const configService = this._configService;
    localStorage.setItem('properties', JSON.stringify(chartproperties));
    let samplesizeconstant = this.samplesizeconstant;
    const maxLabelCharacters = this.popUp ? 30 : 20;
    HC_accessibility(Highcharts);
    this.preparemainChartData(this.data);
    this.preparechartdata(
      this.chartMainData,
      chartproperties.datalabelStyle == 'ls',
      chartproperties.gradientBarColor
    );
    for (let i = 0; i < this.seriesdata[1].data.length; i++) {
      const plotLine: Highcharts.XAxisPlotLinesOptions = {
        value: i,
        width: 1,
        dashStyle: 'Dash',
      };

      this.plotLines.push(plotLine);
    }
    const popup = this.popUpp;
    const options: Highcharts.Options = {
      chart: {
        type: 'bar',
        //  height:,
        backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
        // spacingRight: 70,  // Add padding to the right
        style: {
          fontFamily: this.uniquechartservice.textfont,
          // height:200,
          fontSize: '0.7rem'
        },
        events: {
          load: function () {
            const chart = this;
            // window.addEventListener('resize', function () {
            //   chart.reflow();
            // });
            //#region wheel scroll
              const container = chart.container;
              const xAxis = chart.xAxis[0];

              function onWheel(e: any) {
                e = e || window.event;
                e.preventDefault();

                // Normalize wheel delta
                let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

                const extremes = xAxis.getExtremes();
                const step = 1; // how many categories to scroll at a time

                let newMin = extremes.min + delta * step;
                let newMax = extremes.max + delta * step;

                // Bound checks
                if (newMin < extremes.dataMin) {
                  newMin = extremes.dataMin;
                  newMax = newMin + (extremes.max - extremes.min);
                }
                if (newMax > extremes.dataMax) {
                  newMax = extremes.dataMax;
                  newMin = newMax - (extremes.max - extremes.min);
                }

                xAxis.setExtremes(newMin, newMax, true, false);
              }

              container.addEventListener('wheel', onWheel, {
                passive: false,
              });
            //#endregion
          }
        }
      },
      title: {
        text: "",
        align: chartproperties.chartTitlePosition,
        verticalAlign: 'top',
        style: {
          color: chartproperties.darkTheme ? 'white' : 'black',
        },
      },
      xAxis: {
        lineWidth: 0,
        categories: this.xaxis,
        min: 0,
        max: this.xaxis.length > 8 ? (this.popUp ? 13 : 6) : this.xaxis.length - 1,
        scrollbar: {
          enabled: this.xaxis.length > 4 ? (this.xaxis.length > 8 ? true : false) : false,
          height: 5, // Adjust the height of the scrollbar as needed
          barBackgroundColor: '7f7f7f',//#802AB7,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBackgroundColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBorderWidth: 0,
          buttonArrowColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.chartproperties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5
        },
        labels: {
          useHTML: true,
          style: {
            //fontFamily: this.barService.textfont,
            // Add CSS styles for text overflow
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            color: chartproperties.darkTheme ? 'white' : 'black',
          },
          formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {


            let labelContent = String(this.value);

            //// Limit the number of characters only if axis label orientation is vertical
            //if (properties.axisLabelOrientation === "vertical") {
            if (labelContent.length > maxLabelCharacters) {
              labelContent = labelContent.substring(0, maxLabelCharacters) + '...';
            }
            //}

            return `<div style="width:6.5rem;text-align:right"title="${String(this.value)}">${labelContent}</div>`;

          },



          overflow: 'justify', // Handle overflow with justification
          //rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
        },

        plotLines: chartproperties.horizontalErrorBar ? this.plotLines : [{}],
        gridLineWidth: chartproperties.gridlines ? 1 : 0,
        alternateGridColor: chartproperties.plotBands
          ? !chartproperties.darkTheme
            ? '#eeebed'
            : '#7f7f7f'
          : '',
      },
      yAxis: {
        min: 0,
        max: this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 120 : 140,
        //max:120,
        gridLineWidth: 0,
        visible: false,
      },
      legend: {
        enabled: false,
        reversed: true,
      },
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        // shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',


        formatter: function (this: any): any {
          const pointWithMetric = this.point as {
            name?: any;
            parent?: any;
            actualcolor?: any,
            color?: any;
            y?: number;
            y1?: number;
            cov?: string;
            significance?: string;
            significance2?: string;
            samplesize?: number;
            tooltip?: any;

          };
          if (this.color == 'transparent') {
            return false;
          }
          const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
          const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
          if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

          let isDefaultTooltip = chartproperties.toolTipStyle;
          if (isDefaultTooltip == "style1") {
            const dotColor = pointWithMetric.actualcolor;
            const commonContent =
              `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor};  width: fit-content;z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
              //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
              // `<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
              `${pointWithMetric.name}: ` +
              ` ${pointWithMetric.tooltip}`;
            return commonContent + '</div>';
          }
          else {
            const dotColor = pointWithMetric.actualcolor; // Get the series color

            const content =
              `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>` +
              `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

            return content + '</div>';

          }



        },
      },
      plotOptions: {
        column: {
          pointPadding: 0.1,
          groupPadding: 0.1,
        },
        series: {
          // pointPadding: 0.1,
          // groupPadding: 0.1,
          animation: false,
          stacking: 'percent',
          borderWidth: chartproperties.border ? 2 : 0,
          borderColor: chartproperties.darkTheme ? 'white' : 'black',
          shadow: chartproperties.shadow
            ? {
              color: 'rgba(0, 0, 0, 0.5)',
              offsetX: 1,
              offsetY: 1,
              opacity: 0.5,
              width: 6,
            }
            : false,
          dataLabels: {
            // y:15,
            //x: this.chartproperties.datalabelStyle=='sigChange'?40:this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 40 : 60,
            // x: this.chartproperties.datalabelStyle == 'datalabel' || this._configService.isIndexSelected ? 40 : 65,
            x: this.chartproperties.datalabelStyle == 'datalabel' ? 40 : 65,
            y: 0,
            useHTML: true,
            crop: false,
            overflow: 'allow',
            inside: false,
            enabled: chartproperties.showDataLabel,
            color:
              chartproperties.dataLabelColor == 'default'
                ? chartproperties.darkTheme
                  ? 'white'
                  : 'black'
                : chartproperties.dataLabelColor,
            align:
              chartproperties.dataLabelPosition == 'Center'
                ? 'center'
                : chartproperties.dataLabelPosition == 'Inside Base'
                  ? 'left'
                  : 'right',
            style: {
              fontSize: '0.7em',
              textOutline: 'none',
              fontWeight: "normal"
            },
            formatter: function (
              this: Highcharts.TooltipFormatterContextObject
            ): any {
              ;
              const pointWithMetric = this.point as {
                name?: any;
                color?: any;
                y?: number;
                y1?: number;
                cov?: string;
                significance?: string;
                significance2?: string;
                samplesize?: number;
                tooltip?: any;
                options?: any;
                isPercentage?: any;
                conversion?: any;
                Sig_LowerLimt?: any;
                Sig_UpperLimt?: any;
                Significance_Value?: any;
                indexValue?: any;
                actualIndexValue?:any;
              };
              let textcolor = chartproperties.darkTheme ? 'white' : 'black';
              let paddingRightVal = pointWithMetric.name != "" ? 0 : 25;

              if (chartproperties.datalabelStyle === 'datalabel') {
                let text =
                  pointWithMetric.y1 != null || NaN
                    ? pointWithMetric.y +
                    (chartproperties.dataLabelFormat ? '%' : '')
                    : 'NA';
                text = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                pointWithMetric.tooltip = text;

                let numericValue = parseFloat(text.replace('%', ''));
                paddingRightVal = pointWithMetric.name != "" ? 0 : popup ? 100 : 45;

                if (con != "NaN") {
                  return (
                    '<div >' +
                    '<div style="padding-right:' + paddingRightVal + 'px;">' +
                    text +
                    '</div> '
                    // +'<br>'+'<br>'+'<br>'
                    // +'<div >'+con+'</div> '+'</div>'
                  );
                }
                else {
                  return ('<div style="padding-right:' + paddingRightVal + 'px;">' +
                    text +
                    '</div> ');
                }

              }
              else if (chartproperties.datalabelStyle === "index") {

                let text =
                  pointWithMetric.y1 != null || NaN
                    ? pointWithMetric.y +
                    (chartproperties.dataLabelFormat ? '%' : '')
                    : 'NA';
                text = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");
                // let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                // pointWithMetric.tooltip = text;

                // let numericValue = parseFloat(text.replace('%', ''));
                // let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y : serviceBar.nullValueText;
                // if (text == "0") {
                //   text = "NA";
                // }
                // let color = configService.CheckIndexColoring(text);
                // //// ;
                // this.series.userOptions.tooltip[this.point.x - 1] = text;
                // return (
                //   '<span style="color:' + color + ';">' + text + '</span>'
                // );
                paddingRightVal = pointWithMetric.name != "" ? 0 : popup ? 90 : 50;



                // let text2 = pointWithMetric.y1==0?'NA':pointWithMetric.y1 == -1 ? -1 :
                //   pointWithMetric.y1 != null
                //     ? pointWithMetric.indexValue.toFixed(1)
                //     : 'NA';
                let text2 = pointWithMetric.actualIndexValue==null?'NA':pointWithMetric.y1 == -1 ? -1 :
                  pointWithMetric.y1 != null
                    ? pointWithMetric.indexValue.toFixed(1)
                    : 'NA';
                if (text2 == "-1" || text2 == -1) {
                  text2 = "NA";
                }
                //text2 = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, text2 + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                let color = configService.CheckIndexColoring(String(text2));
                pointWithMetric.tooltip = text+"("+text2+")";

                let con = parseFloat(pointWithMetric.options.conversion).toFixed(1);
                pointWithMetric.tooltip = text+"("+text2+")";
                if (con != "NaN") {
                  return (
                    '<div>' +
                      '<div style="color: ' + (pointWithMetric.name === "" ? 'white' : 'black') + '; padding-right: ' + paddingRightVal + 'px;">' +
                        text + '(<span style="color:' + (pointWithMetric.name === "" ? 'white' : color) + ';">' + text2 + '</span>)' +
                      '</div>' +
                    '</div>'
                  );


                }
                else {
                  return (
                    '<div style="color: ' + (pointWithMetric.name == "" ? 'white' : color) + '; padding-right: ' + paddingRightVal + 'px;">' +
                      text + '(' + text2 + ')' +
                    '</div>'
                  );

                }
                // return (
                //   '<span style:"color:' + color + ';">' + text + '</span>'
                // );

              }
              else if (chartproperties.datalabelStyle === 'sigChange') {
                let textCheck = pointWithMetric.name != "" ? (configService.CheckLSorIScondition(configService.userRole, pointWithMetric.y1 + (pointWithMetric.isPercentage && (!configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y1), Number(pointWithMetric.samplesize)).includes('I/S') || !configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y1), Number(pointWithMetric.samplesize)).includes('NA')) ? '%' : ''), Number(pointWithMetric.samplesize))) : (!isNaN(pointWithMetric.conversion) ? (parseFloat(pointWithMetric.conversion).toFixed(1)) : pointWithMetric.conversion) + (pointWithMetric.conversion.toString().includes('I/S') || pointWithMetric.conversion.toString().includes('NA') ? "" : "%");

                //paddingRightVal = pointWithMetric.name != "" ? 0 : 30;
                if (pointWithMetric.name == '') {
                  let text = textCheck;
                  // pointWithMetric.y1 != null
                  //   ? pointWithMetric.y +
                  //   (pointWithMetric.isPercentage ? '%' : '')
                  //   : 'NA';
                  pointWithMetric.tooltip = text;

                  let numericValue = parseFloat(text.replace('%', ''));
                  paddingRightVal = pointWithMetric.name != "" ? 0 : popup ? 90 : 50;

                  return (
                    '<span style="padding-right:' + (paddingRightVal + 20) + 'px; color:' + textcolor + '; ">' + text + '</span>'
                  );
                }
                else {
                  let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                  let sigClass = pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                  if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                    let text = textCheck +
                      // pointWithMetric.y1 != null
                      //   ? pointWithMetric.y +
                      //   (pointWithMetric.isPercentage ? '%' : '') +
                      '<span style="color:' +
                      sigClass +
                      ';font-size:80%;">(NA)</span>';

                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + textcolor + ';">' + text + '</span>'
                    );
                  }
                  else {
                    let text = textCheck +
                      // pointWithMetric.y1 != null
                      //   ? pointWithMetric.y +
                      //   (pointWithMetric.isPercentage ? '%' : '') +
                      (textCheck != 'I/S' ? ('<span style="color:' +
                        sigClass +
                        '; font-size:80%">(' +
                        ((changeVal.toFixed(1)) + (pointWithMetric.isPercentage ? '%' : '')) +
                        ')</span>') : '');

                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + textcolor + ';">' + text + '</span>'
                    );
                  }
                }
                // const upwardTriangle = '\u25B2';
                // const downwardTriangle = '\u25BC';
                // let sig = Number(pointWithMetric.significance);
                // let s =
                //   sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                // let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

                // let text =
                //   pointWithMetric.y1 != null
                //     ? pointWithMetric.y +
                //     (chartproperties.dataLabelFormat ? '%' : '') +
                //     '<span style="color:' +
                //     sigcolor +
                //     ';">' +
                //     pointWithMetric.cov +
                //     '</span>'
                //     : 'NA';
                // pointWithMetric.tooltip = text;
                // return (
                //   '<span style:"color:' + textcolor + ';">' + text + '</span>'
                // );
              }
              else if (chartproperties.datalabelStyle === 'change') {
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                    (chartproperties.dataLabelFormat ? '%' : '') +
                    ' ' +
                    `<span span style="font-size: 80%;color:` +
                    (chartproperties.darkTheme ? 'white' : 'black') +
                    `">(` + `${pointWithMetric.cov} )</span>`
                    : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' + textcolor + ';">' + text + '</span>'
                );
              } else if (
                chartproperties.datalabelStyle === 'significance + changeVs'
              ) {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let sig = Number(pointWithMetric.significance);
                let s =
                  sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                    (chartproperties.dataLabelFormat ? '%' : '') +
                    ' ' +
                    `<span span style="font-size: 80%;color:` +
                    (chartproperties.darkTheme ? 'white' : 'black') +
                    `">(` +
                    (Number(pointWithMetric.cov) > 0 ? '+' : '') +
                    `${pointWithMetric.cov} )</span>` +
                    '<span style="color:' +
                    sigcolor +
                    ';">' +
                    s +
                    '</span>'
                    : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' + textcolor + ';">' + text + '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'significance') {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let sig = Number(pointWithMetric.significance);
                let s =
                  sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                    (chartproperties.dataLabelFormat ? '%' : '') +
                    '<span style="color:' +
                    sigcolor +
                    ';">' +
                    s +
                    '</span>'
                    : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' + textcolor + ';">' + text + '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'ls') {
                let text =
                  Number(pointWithMetric.samplesize) > samplesizeconstant
                    ? pointWithMetric.y1 == null
                      ? 'NA'
                      : pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                    : 'LS';
                pointWithMetric.tooltip = text;
                return (
                  '<span>' +
                  pointWithMetric.name +
                  '</span> <span>' +
                  text +
                  '</span> ' +
                  '<span style="opacity: 0.5"></span>'
                );
              } else if (chartproperties.datalabelStyle == 'significance2') {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let text =
                  pointWithMetric.y1 != null
                    ? this.y + (chartproperties.dataLabelFormat ? '%' : '')
                    : 'NA';
                let changeText = pointWithMetric.cov;
                let sig = Number(pointWithMetric.significance);
                let sig1 = Number(pointWithMetric.significance2);
                let sColor =
                  Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                let s =
                  Number(sig) > 0
                    ? upwardTriangle
                    : Number(sig) < 0
                      ? downwardTriangle
                      : '';
                let changeColor =
                  sig1 < 0
                    ? 'red'
                    : sig1 > 0
                      ? 'green'
                      : chartproperties.darkTheme
                        ? 'white'
                        : 'black';
                if (Number(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                pointWithMetric.tooltip = text;
                return (
                  '<span>' +
                  text +
                  (pointWithMetric.y1 != null && changeText
                    ? '&nbsp<span style="color:' +
                    ';"> ' +
                    '<span style="font-size: 80%; color:' +
                    changeColor +
                    ';">(' +
                    changeText +
                    ')</span> &nbsp' +
                    '<span style="color:' +
                    sColor +
                    ';">' +
                    s +
                    '</span>'
                    : '') +
                  '</span>'
                );
              }
            },
          },
        },
      },
      series: this.seriesdata,

      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
    }
    const containerEl = document.getElementById('chart-container' + this.id);
    if (!containerEl) { return; }
    Highcharts.chart(containerEl, options);
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.uniquechartservice.applycustomization(event, item, this.chartproperties)
    this.plotChart(
      'chart-container',
      this.jsondata['data'],
      this.chartproperties
    );
  }

  userselectedproperties() {
    this.jsondata['data'] = this.jsondata['data'];
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    if (this.chart) { this.chart.destroy(); this.chart = null; } 
     this.subscriptions.unsubscribe();
  }
}
